<template>
  <div v-if="current">

    <v-card width="100%">
      <v-card-title>Dados do registro</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-12 col-sm-1">
              <v-text-field
                label="Nome"
                v-model="current.name"
                outlined
                dense
              ></v-text-field>
            </div>
            <div class="col-md-12 col-sm-1">
              <v-textarea
                label="Opções"
                v-model="current.options"
                outlined
                dense
              ></v-textarea>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div>
          <v-btn color="success" @click="save()">Salvar</v-btn>
        </div>
      </v-card-actions>
    </v-card>
    
  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: () => ({
    current: null,
  }),
  created: function () {
    this.load();
  },
  methods: {
    load: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/partner/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.current = response.data;
        })
        .catch(function () {
          console.log("load fail");
        });
    },
    save: function () {
      var token = localStorage.getItem("token");
      if (this.current.id == 0) {
        api
          .post("/partner", this.current, {
            headers: { Authorization: "Bearer " + token },
          })
          .then(function () {
            alert("Cadastrada com sucesso!");
            router.push({ path: "/partner" });
          })
          .catch(function () {
            console.log("save fail");
          });
      } else {
        api
          .put("/partner/" + this.current.id, this.current, {
            headers: { Authorization: "Bearer " + token },
          })
          .then(function () {
            alert("Atualizada com sucesso!");
            router.push({ path: "/partner" });
          })
          .catch(function () {
            console.log("save fail");
          });
      }
    },
  },
};
</script>